import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "Zignature",
  description: _package.description,
  installed: true,
  category: "automation",
  categories: ["automation"],
  logo: "icon.png",
  publisher: "Schedly, LLC",
  slug: "zignature",
  title: "Zignature",
  type: "zignature_other",
  url: "https://zignature.io",
  variant: "other",
  extendsFeature: "EventType",
  email: "info@schedly.io",
  dirName: "zignature",
  isOAuth: true,
} as AppMeta;

export default metadata;
